import _ from 'lodash'
import type {DocumentServicesObject} from '@wix/document-services-types'
import type {OverlayManager} from '../overlayManager/overlayManager'
import {type DAL, pointerUtils} from '@wix/document-manager-core'
import type {MobileAlgoApi} from '@wix/document-manager-extensions/src/extensions/mobileAlgo/mobileAlgo'
import {NEW_ALGO} from '../constants'
import {getSections} from './utils/sections'
import type {StructureIterators} from '@wix/document-manager-extensions/src/extensions/mobileAlgo/types'
import {constants} from '@wix/document-manager-extensions'

const {VIEW_MODES} = constants

const displayOrderIndicationsNew = (overlayManager: OverlayManager, structureIterators: StructureIterators) => {
    structureIterators.forEachComponent(component => {
        _.forEach(component.components, (child, index) => {
            overlayManager.markComponent([child], NEW_ALGO, `new-algo:${index}`, 'yellow', '0', '')
        })
    })
}

const displayOrder = async (mobileAlgo: MobileAlgoApi, sections: string[], overlayManager: OverlayManager) => {
    for (const id of sections) {
        const ctx = mobileAlgo.context.create(['grouping', 'order'])
        const containerPointer = pointerUtils.getCompPointer(id, VIEW_MODES.DESKTOP)
        const conversionConfig = mobileAlgo.createConversionConfig(containerPointer)
        const {structureIterators} = await mobileAlgo.runWithContext(containerPointer, ctx, conversionConfig)
        displayOrderIndicationsNew(overlayManager, structureIterators)
    }
}

export const displayOrderSingleSection = async (
    mobileAlgo: MobileAlgoApi,
    sectionId: string,
    overlayManager: OverlayManager
) => {
    await displayOrder(mobileAlgo, [sectionId], overlayManager)
}

export const displayOrderAllSections = async (
    documentServices: DocumentServicesObject,
    mobileAlgo: MobileAlgoApi,
    overlayManager: OverlayManager,
    dal: DAL
) => {
    const currentPageSections = getSections(dal, documentServices.pages.getCurrentPageId())
    await displayOrder(mobileAlgo, currentPageSections, overlayManager)
}
